var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[(_vm.isError)?_c('div',[_c('h2',[_vm._v(_vm._s(_vm.errorMessage))]),_c('a',{attrs:{"href":"/"}},[_vm._v("Go Home")])]):_c('div',{staticClass:"content placeholder"},[_c('LoadingPlaceholder',{attrs:{"state":_vm.pageState}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }